export const CATERING_HREF = '/order-catering';
